export default "__VITE_ASSET__DQB_Pzhe__"